import React from "react";
import { videoActualizacion, Actualizacion3, Actualizacion4, Actualizacion5 } from "../assets";
import styles from "../style";
import { motion } from "framer-motion";

const VideoSection = () => (
  <section id="video" className={`${styles.paddingY} max-w-7xl mx-auto w-full scroll-mt-24`}>
    {/* Encabezado */}
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="text-center mb-8 sm:mb-12 px-4 sm:px-6"
    >
      <h2 className={`${styles.heading2} mb-3 sm:mb-5 text-2xl sm:text-3xl md:text-4xl`}>
        Nuestro Proyecto en Acción
      </h2>
      <p className={`${styles.paragraph} max-w-2xl mx-auto text-slate-500 text-sm sm:text-base px-2`}>
        Mirá el VAE en funcionamiento durante las pruebas de campo.
      </p>
    </motion.div>

    {/* Contenedor de dos columnas */}
    <div className="flex flex-col lg:flex-row gap-6 sm:gap-8 mt-8 sm:mt-12 px-4 sm:px-6">
      {/* Columna izquierda: Video + Actualizacion5 debajo */}
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="lg:w-2/3 w-full flex flex-col gap-4 sm:gap-6"
      >
        <div className="relative w-full aspect-video rounded-2xl sm:rounded-3xl overflow-hidden border border-slate-100 bg-darkBlue shadow-xl sm:shadow-2xl transform-gpu transition-all duration-500 hover:shadow-slate-200/50">
          <video
            src={videoActualizacion}
            controls
            playsInline
            preload="metadata"
            className="w-full h-full object-cover block relative z-10"
            style={{
              transform: "translateZ(0)",
              backfaceVisibility: "hidden",
              WebkitFontSmoothing: "antialiased",
            }}
          />
        </div>
        {/* Imagen Actualizacion5 */}
        <img
          src={Actualizacion5}
          alt="Actualización 5"
          className="w-full h-auto object-cover rounded-2xl sm:rounded-3xl shadow-xl"
        />
      </motion.div>

      {/* Columna derecha: Actualizacion1 y Actualizacion4 */}
      <div className="lg:w-1/3 w-full flex flex-col gap-4 sm:gap-8">
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
        >
          <img
            src={Actualizacion3}
            alt="Detalle VAE 1"
            className="w-full h-auto object-cover rounded-2xl sm:rounded-3xl shadow-xl"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.3 }}
        >
          <img
            src={Actualizacion4}
            alt="Detalle VAE 4"
            className="w-full h-auto object-cover rounded-2xl sm:rounded-3xl shadow-xl"
          />
        </motion.div>
      </div>
    </div>
  </section>
);

export default VideoSection;